export const CANOPI_FUND_PROJECT_ID = "60efc85100de487da31af3d7"